import { routerKey } from "vue-router";

export const useErrorStore = defineStore('error', {
    state: () => ({
        error: null as { statusCode: number; message: string } | null,
        isErrorPageOpen: false,
        has500Error: false,
    }),
    getters: {
        getIsErrorPageOpen(state) {
            return state.isErrorPageOpen
        },
        getHas500Error(state) {
            return state.has500Error
        },
    },
    actions: {
        setError(error: { statusCode: number; message: string }) {
            this.error = error;
        },
        clearError() {
            const router = useRouter()
            this.error = null;
            this.setIsErrorPageOpen(false);
            router.back()
        },
        async setIsErrorPageOpen(newVal: boolean) {
            this.isErrorPageOpen = newVal;
        },
        set500Error(status:boolean) {
            this.has500Error = status;
          },
    },
});
